import React, { Component } from 'react';
import UploadFileModal from './UploadFileModal';
import UploadFileCon from '$Deposits/Components/Components/UploadFile'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
class UploadFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadVisible: false,
        };
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {

    }
    componentWillUnmount() {

    }


    render() {
        const { LivechatClick, webPiwikEvent } = GetParamsData()
        const { uploadVisible } = this.state;
        return (
            <>
                <UploadFileCon
                    UploadFile={(propCon) => {
                        const {
                            RemoveUploadFile,
                            SetUploadFileList,
                            UploadFileErr,
                            UploadFileList,
                            toggleLoading
                        } = propCon
                        const { fileName = false } = UploadFileList && UploadFileList[0] || {}
                        return (
                            <div className='uploadFile'>
                                <div className='upload'>
                                    <span>Biên Lai Gửi Tiền</span>
                                    <span className='uploadSlip'>Khuyến Khích</span>
                                </div>
                                <div className='fileList'>
                                    {fileName ?
                                        <div className='uploaded'>
                                            {fileName}
                                            <span className='removeIcon' onClick={RemoveUploadFile} />
                                        </div>
                                        :
                                        <div className='uploadUp' onClick={() => { webPiwikEvent("Deposit", "Upload Slip", "Deposit_Old_Bank_C_Upload"); this.setState({ uploadVisible: true }) }}>
                                            <div className='add'>+</div>
                                            <div>Đăng Tải Biên Lai</div>
                                        </div>
                                    }
                                </div>
                                <div className='uploadfileRemark'>Nếu bạn không thể đăng tải biên lai, vui lòng <span onClick={LivechatClick}>liên hệ Live Chat</span></div>

                                {/* 上傳檔案跳窗 */}
                                <UploadFileModal
                                    visible={uploadVisible}
                                    setVisible={(status) => { this.setState({ uploadVisible: status }) }}
                                    RemoveUploadFile={RemoveUploadFile}
                                    SetUploadFileList={SetUploadFileList}
                                    UploadFileErr={UploadFileErr}
                                    fileName={fileName}
                                    toggleLoading={toggleLoading}
                                />
                            </div>
                        )
                    }}
                />
            </>

        );
    }
}

export default UploadFile
